import { produce } from "immer";

import {
  resetSearch,
  swapDirections,
  updatePassengers,
  updateSearch,
  updateDestination,
  validatePassengers,
} from "./actions";

const applyPassengersValidation = (state) => {
  const { passengers } = state.search;
  const adultCompanions =
    passengers.adult + passengers.senior + passengers.youth;
  const hasPreschoolChild = passengers.child > 0;
  const onlyPupilAndChild =
    passengers.pupil > 0 && adultCompanions === 0 && hasPreschoolChild;

  if (hasPreschoolChild && adultCompanions === 0 && passengers.pupil === 0) {
    const childrenToRemove = passengers.child;
    state.search.passengers.child = 0;
    state.search.passengersCount -= childrenToRemove;
    state.search.preschoolChildWarning = true;
  } else if (onlyPupilAndChild) {
    state.search.preschoolChildWarning = true;
  } else {
    state.search.preschoolChildWarning = false;
  }
};

const initialSearchState = {
  promocode: "",
  approvedPromo: false,
  passengers: {
    adult: 0,
    senior: 0,
    youth: 0,
    pupil: 0,
    child: 0,
  },
  passengersCount: 0,
  departDate: new Date(),
  returnDate: "",
  from: {
    search: "",
    BusStopId: "",
  },
  to: {
    search: "",
    BusStopId: "",
  },
  search: "", // check and remove this field
  field: "",
  isSearchValid: false,
  preschoolChildWarning: false,
};

export const searchSlice = (set, gets) => ({
  ...initialSearchState,
});

export const searchActions = (set, get) => ({
  [resetSearch]: () => {
    set((state) => ({
      ...state,
      search: {
        ...initialSearchState,
      },
    }));
  },

  [updateSearch]: (payload) => {
    set((state) => ({
      ...state,
      search: {
        ...state.search,
        ...payload,
      },
    }));
  },
  [updateDestination]: (payload, fieldName) => {
    set(
      produce((state) => {
        state.search[fieldName] = {
          ...state.search[fieldName],
          ...payload,
        };
      }),
    );
  },
  [swapDirections]: () => {
    set((state) => ({
      ...state,
      search: {
        ...state.search,
        from: state.search.to,
        to: state.search.from,
      },
    }));
  },

  [updatePassengers]: (type = null, newValue = null) =>
    set(
      produce((state) => {
        if (!type || newValue === null || newValue < 0) return;

        const currentValue = state.search.passengers[type];
        const difference = newValue - currentValue;

        const newTotalCount = state.search.passengersCount + difference;
        if (newTotalCount < 0) return;

        state.search.passengersCount = newTotalCount;
        state.search.passengers[type] = newValue;

        applyPassengersValidation(state);
      }),
    ),

  [validatePassengers]: () =>
    set(
      produce((state) => {
        applyPassengersValidation(state);
      }),
    ),
});
